// extracted by mini-css-extract-plugin
module.exports = {"projectsList":"ProjectsList_projectsList__q9upz"};